import Styles from './NodeViewCard.module.scss';
import React from 'react';
// Module imports.
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
// Components import.
import { useTranslation } from 'components/lib'

const NodeViewCard = (props) => {

	const { t } = useTranslation();
	const { data } = props;
	const nodeDisabled = props.data.isDisabled || props.trialExpired;
	return (
		<div className={Styles.container}
			onClick={nodeDisabled ? null : () => props.onClick(data.id)}
			style={{
				backgroundColor: data.is_assessment ? '#1450a04a' : '#fff'
			}}
		>
			{/* Image Part */}
			<div className={Styles.imageContainer}>
				<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data.icon}`}
					className={Styles.courseImage} alt="courseImg"
				/>
			</div>
			{/* Content Part */}
			<div className={Styles.contentContainer}>
				<p className={Styles.headerText}>{data.name}</p>
				<p className={Styles.descriptionText}>{data.descr}</p>
			</div>
			{/*Button  Part */}
			<div className={Styles.buttonContainer}>
				<button
					className={Styles.startButton}
					variant="contained"
					disabled={nodeDisabled}
				>
					{nodeDisabled && (
						<LockIcon sx={{ mr: "-1px" }} />
					)}
					{props.data.isCompleted && (
						<CheckCircleIcon sx={{ mr: "-1px" }} />
					)}
					{!props.data.isCompleted && !nodeDisabled && (
						<PlayCircleFilledIcon sx={{ mr: "-1px" }} />
					)}
					{props.trialExpired ? 'Trial Expired' : props.button_text}
				</button>
				<div style={{ fontWeight: 600, display: data.is_assessment ? '' : 'none', padding: "5px", borderRadius: "4px" }}>
					{t('Labs.UserNodes.nodeViewCard.score', { score: data.AssessmentScore })}
				</div>
			</div>
		</div>
	);
};

export default NodeViewCard;